module.exports = __webpack_public_path__ + "img/14.21c06192.png";